import useCollection from "./useCollection";

export default function CollectionTitle({
    className = "",
}) {

    const collection = useCollection();

    if (!collection)
        return null;

    return (
        <div className={`collection-title ${className}`}>

            <h1>
                 محصولات
                  {" "}
                {collection.title}

            </h1>

        </div>
    );
}